import * as React from "react";
import { TextField, TextFieldProps } from "@material-ui/core";

const TrimmedTextField = (props: TextFieldProps) => (
  <TextField {...props} onBlur={(e) => props.onChange?.({ ...e, target: { ...e.target, value: e.target.value.trim() } })} />
);

export default TrimmedTextField;
